import { c } from "./colors";
import { Frame, type IllustrationProps } from "./Frame";

export function AiAgentIllustration(props: IllustrationProps) {
  return (
    <Frame {...props}>
      <path d="M80 48V36" stroke={c.p700} strokeWidth="4" />
      <circle cx="80" cy="30" r="7" fill={c.a400} />
      <rect x="30" y="68" width="12" height="28" rx="6" fill={c.p300} />
      <rect x="118" y="68" width="12" height="28" rx="6" fill={c.p300} />
      <rect x="62" y="112" width="36" height="16" rx="6" fill={c.p300} />
      <rect x="40" y="48" width="80" height="66" rx="22" fill={c.p500} />
      <rect x="50" y="60" width="60" height="42" rx="16" fill={c.n0} />
      <circle cx="66" cy="78" r="6" fill={c.p700} />
      <circle cx="94" cy="78" r="6" fill={c.p700} />
      <circle cx="56" cy="90" r="4" fill={c.a200} />
      <circle cx="104" cy="90" r="4" fill={c.a200} />
      <path d="M70 90q10 7 20 0" stroke={c.p700} strokeWidth="4" />
    </Frame>
  );
}
